import React from 'react';
import styles from './RefreshRoundButton.module.css';

interface Props {
  onClick: () => void;
  className?: string;
}

const RefreshRoundButton = ({onClick, className}: Props) => {
  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    const button = e.currentTarget;
    button.classList.add(styles.rotating);
    setTimeout(() => button.classList.remove(styles.rotating), 500);
    onClick();
  };

  return (
    <button
      className={`${className ? className : ''} ${styles.refreshRoundButton}`}
      onClick={handleClick}>
      <span className="icon-typeReload"></span>
    </button>
  );
};

export default RefreshRoundButton;
